module.exports = __webpack_public_path__ + "img/pig-nose.2703409b.png";